export default "__VITE_ASSET__094f1202__"